import React, { useEffect, useState } from "react";
import "./CohortPage.scss";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Filters from "./CohortFilter/Filters";
import CohortList from "./CohortList/CohortList";
import CohortView from "./CohortView/CohortView";
import AdditionalInstitutions from "./CohortFilter/AdditionalInstitutions";
import exportimages from "../../../assets/images/exportImages";

const CohortPage = () => {
  const [isAddRemoveInProgress, setIsAddRemoveInProgress] = useState(false);
  useEffect(() => {
    if (isAddRemoveInProgress) {
      setTimeout(() => setIsAddRemoveInProgress(false), 1000);
    }
  }, [isAddRemoveInProgress]);
  const orgReducer = useSelector((state) => state?.orgReducer);
  const navigate = useNavigate();
  const navigationHistoryReducer = useSelector(
    (state) => state.navigationHistoryReducer,
  );

  const cohortApplied = useSelector(
    (state) => state?.cohortReducer?.cohortApplied,
  );

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  return (
    <div className="dashboardContainer position-relative " id="alldata">
      <div className="row p-4">
        <div className="col-md-5 col-sm-12  ">
          <div className="custom-theme pageTitle">
            <h3 className="text-dark fs-page-title fw-bolder lh-lg mb-1 dashboard-title">
              Cohort Management
            </h3>
          </div>
          {/* <CustomBreadcrumb campaignId={campaignId} /> */}
          <div
            className="custom-theme pageSubTitle fs-7 text-868687 "
            style={{ fontSize: "12px" }}
          >
            <span
              style={{
                display: navigationHistoryReducer.isPathFromCluster
                  ? "none"
                  : "inline-block",
              }}
            >
              <Link
                id="dashboard_link_to_cohort"
                to={`/bank/health-analysis/report/${
                  orgReducer?.healthAnalysisID?.uid
                    ? orgReducer?.healthAnalysisID?.uid
                    : "no-analysis-id"
                }`}
                style={{ color: "#868687" }}
              >
                <span className="fs-breadcrumbs ms-1">Dashboard</span>
              </Link>
              {" > "}
            </span>
            <span>
              <Link
                id="fhs_details_link_to_cohort"
                // to={`/bank/campaign-management/create-campaign?consumerID=${sessionStorage.getItem(
                //   "campaignConsumerID",
                // )}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  navigate(-1);
                }}
                style={{
                  color: "#868687",
                  // display: navigationHistoryReducer.isPathFromCluster
                  //   ? "inline-block"
                  //   : "none",
                }}
              >
                <span className="fs-breadcrumbs ms-1">
                  Financial Performance Overview
                </span>
              </Link>
              {" > "}
              {"  "}
              <Link
                id="graph_link_to_report"
                to={`/bank/cohort-management`}
                style={{
                  color: "#868687",
                  // display: navigationHistoryReducer.isPathFromCluster
                  //   ? "none"
                  //   : "inline-block",
                  // pointerEvents:
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.QUEUE_CAMPAIGN ||
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.ACTIVE_CAMPAIGN ||
                  //   emailCampaignData?.status ===
                  //     EMAIL_CAMPAIGN_STATUS.COMPLETE_CAMPAIGN
                  //     ? "none"
                  //     : "auto",
                }}
              >
                <span className="text-4b4b4b fs-breadcrumbs text-decoration-underline ms-1">
                  Cohort Management
                </span>
              </Link>
            </span>
          </div>
        </div>
        <div
          className="col-md-7 col-sm-12 text-end mb-4"
          style={{ fontWeight: "normal!important" }}
        >
          <button
            type="button"
            id="kt_login_password_reset_form_cancel_button"
            onClick={() => {
              navigate(-1);
            }}
            className="mr-4 btn btn-outline-primary border-primary btn-bond mb-2 mt-2 "
          >
            <img
              alt="back-arrow"
              src={exportimages?.backArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImage"
            />
            <img
              alt="back-arrow"
              src={exportimages?.hoverBackArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImageHover"
            />
            <span
              className="me-3 fs-btn-text fs-xxl-6 "
              style={{ fontWeight: "normal" }}
            >
              Back{" "}
            </span>
          </button>

          {/* {hasPermission(PRIVILEGES.EDIT_EMAIL_CAMPAIGN) && (
            <button
              type="button"
              id="kt_login_password_reset_form_cancel_button"
              onClick={() => {
                navigate(
                  `/bank/campaign-management/edit-campaign/${campaignId}`,
                );
              }}
              disabled={
                hasSubscription(PRIVILEGES.EDIT_EMAIL_CAMPAIGN)
                  ? emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.QUEUE_CAMPAIGN ||
                    emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.ACTIVE_CAMPAIGN ||
                    emailCampaignData?.status ===
                      EMAIL_CAMPAIGN_STATUS.COMPLETE_CAMPAIGN
                  : true
              }
              className="btn btn-primary border-primary btn-bond mb-2 mt-2 "
            >
              <span className="fs-btn-text fw-normal">Edit Campaign</span>
            </button>
          )} */}
        </div>
      </div>

      <div
        className="row g-8 px-8 cohort-page"
        // style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div className="col-md-8 cohort-filter-section">
          <div className="row">
            <div className="col-md-6">
              <div className="outline-card">
                <CohortList />
              </div>
            </div>
            <div className="col-md-6">
              <div className="outline-card" style={{ border: "none" }}>
                <div className="card border mb-8">
                  <Filters />
                </div>
                {(selectedCohort != null || cohortApplied?.cohort != null) && (
                  <div className="card border">
                    <AdditionalInstitutions
                      isAddRemoveInProgress={isAddRemoveInProgress}
                      setIsAddRemoveInProgress={setIsAddRemoveInProgress}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 cohort-view-section">
          <div className="col-md-12">
            <CohortView
              isAddRemoveInProgress={isAddRemoveInProgress}
              setIsAddRemoveInProgress={setIsAddRemoveInProgress}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CohortPage;
